import React from 'react';

import Button from '@atlaskit/button';
import CheckIcon from '@atlaskit/icon/glyph/check';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';

import './_test-step-actions.scss';

type Props = {
  testStepIndex: number;
  deleteTestStep: (stepIndex: number) => void;
  saveTestStep: () => Promise<void>;
};

export default function TestStepActions({
  testStepIndex,
  deleteTestStep,
  saveTestStep,
}: Props): JSX.Element {
  return (
    <div className='step-actions'>
      <div className='pointer' style={{ paddingRight: '3px' }}>
        <Button
          onFocus={() => {
            saveTestStep();
          }}
          iconBefore={<CheckIcon size='small' label='' />}
          onClick={() => saveTestStep()}
        />
      </div>
      <div className='pointer'>
        <Button
          onClick={() => deleteTestStep(testStepIndex)}
          iconBefore={<EditorCloseIcon size='small' label='' />}
        />
      </div>
    </div>
  );
}
